// This is a template file - DO NOT use directly
// The actual environment.ts is generated at build time from GitHub environment variables
// See: bin/generate-frontend-env.js

export const environment = {
    production: true,
    useMock: false,
    authClientId: 'caf51395-1296-4137-aa7f-b93bea50bef3',
    authAuthority: 'https://login.microsoftonline.com/0ef544fb-3d5c-4c60-932e-735bcef00405/',
    authScopes: [],
    azureApiKey: 'pj37PZ3H47u76prChBNUoN9j8nKXhqwZtbYfuf0H0pg',
};
